<template lang="pug">
.main-wrapper
    .nav-wrapper
        Navigation
    VGrid.container.project-content.fade-in(variant="container")
        .title-section-wrapper
            .title-section-inner-wrapper
                .title-section-image(ref="parallax1")
                    img.main-image.large(
                        src="@/assets/images/swift-mockups/banner.png",
                        data-depth="0.3"
                    )
                    img.dot-pattern(
                        src="@/assets/dot-pattern-2.svg",
                        data-depth="0.05"
                    )
                    .outline-square(data-depth="0.15")
                    .filled-squares(data-depth="0.15")
                .title-section-content-container
                    .project-information
                        h1.title-section-title Swift <br/> POS <br/> System
                        .title-section-description
                            .company By Influx.Studio
                            .description We designed the Swift visual identity from the ground up, <br/> capturing the new companies excitement and value in a new <br/> logo and brand style guidelines. We then built a highly-effective <br/> system that helps create a contactless dining experience.
                    .title-section-content
                        span.project-focus Project Focus <br/>
                        span.project-focus-items Software, Retail & Branding
                        .project-menu
                            .menu-item
                                a.label.active(data-link="#overview") 01 Overview
                            .menu-item
                                a.label(data-link="#brand") 02 Brand
                            .menu-item
                                a.label(data-link="#customer") 03 Customer App
                            .menu-item
                                a.label(data-link="#management") 04 Management App
                            .menu-item
                                a.label(data-link="#solutions") 05 Solutions
                            .menu-item
                                a.label(data-link="#technologies") 06 Technologies

            .title-section-gridlines

    .light
        VGrid#overview.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Overview
            VRow.overview-section-spacing
                VCol(variant="xs-10")
                    VRow.space-around
                        VCol(variant="xs-6")
                            .general-item 
                                span.title The Mission
                                p.description Swift aims to create a convenient, flexible, and scalable interface suitable for both customers and restaurants giving users the opportunity to order, track and pay for their food immediately. The application will also use Augmented Reality to show real live photogrammetry models of the food, making the menu come to life
                        VCol(variant="xs-6") 
                            .general-item 
                                span.title Services
                                p.description Swift consists of a customer and a management application that offers services such as order management, business logic, creating a customisable menu, live order status tracking, Augmented Reality menu items, Machine Learning recommendations, and many more.
                        VCol(variant="xs-6") 
                            .general-item 
                                span.title The Outcome
                                p.description The software system must perform smoothly and accurately in real time, in a bid to attract a substantial number of both restaurants and customers to employ the system. The design of the system must strive to be user friendly, clean, and easy to use to ensure a minimal learning curve. Restaurants will have the opportunity to better market their business using AR technology to map the food items as well as updates on current specials.
                        VCol(variant="xs-6") 
                            .general-item 
                                span.title The Impact
                                p.description Improve the customer restaurant experience and increase the restaurant customer conversion rate.
                VCol(variant="xs-2") 
                    span.general-section-share Share This
                    .general-section-social-share
                        VRow
                            VCol(variant="xs-2") 
                                a.contact-info-social(
                                    href="https://www.facebook.com/",
                                    target="_blank",
                                    data-cursor-shrink
                                )
                                    img(src="@/assets/facebook.svg") 
                            VCol(variant="xs-2") 
                                a.contact-info-social(
                                    href="https://twitter.com/?lang=en",
                                    target="_blank",
                                    data-cursor-shrink
                                )
                                    img(src="@/assets/twitter.svg") 
                            VCol(variant="xs-2") 
                                a.contact-info-social(
                                    href="https://www.instagram.com/",
                                    target="_blank",
                                    data-cursor-shrink
                                )
                                    img(src="@/assets/insta.svg") 
                    .general-section-project-scope
                        span.scope Scope of Project
                        .scope-item Strategy
                        .scope-item Messaging
                        .scope-item Branding
                        .scope-item E-blast Template
                        .scope-item Marketing Brochure
                    a.website-link.spacing(href="https://app.swiftapp.ml/#/") Customer Application
                    a.website-link(href="https://manage.swiftapp.ml/") Management Application
                    a.website-link(href="https://docs.swiftapp.ml/") Documentation
                    //- a.website-link(href="https://github.com/COS301-SE-2020/Swift")

    .light-grey
        VGrid#brand.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Promotional video
            VRow.side-scroll
                VCol(variant="xs-12")
                    video.promo-video(
                        src="@/assets/videos/swift-promo.mp4",
                        controls
                    )

    .light
        VGrid.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Defining the Brand
            VRow.overview-section-spacing
                VCol(variant="xs-4")
                    p.section-description Through a series of exercises in the strategy session, we were able to extract and refine the key pillars of the brand. This defined the brand’s personality: how it should look, sound, and act.
            VRow
                VCol(variant="xs-12")
                    .slogan-section
                        h1.brand-slogan Creating a New<br/> <span class="slogan-outline">Contactless Dining Experience</span> <br/> for Restaurants & Customers

    .light
        VGrid#customer.container(variant="container")
            VRow
                VCol.image-scroll-section(variant="xs-7")
                    .image-section 
                        img.left-image(
                            src="@/assets/images/swift-mockups/mockup-2.png",
                            data-depth="0.3"
                        ) 
                        p.figure-text-left Restaurant Menu
                    .image-section 
                        img.right-image(
                            src="@/assets/images/swift-mockups/mockup-3.png",
                            data-depth="0.3"
                        )
                        p.figure-text-right Payment Method
                    .image-section 
                        img.left-image(
                            src="@/assets/images/swift-mockups/mockup-4.png",
                            data-depth="0.3"
                        )
                        p.figure-text-left Menu Item
                    .image-section 
                        img.right-image(
                            src="@/assets/images/swift-mockups/mockup-5.png",
                            data-depth="0.3"
                        )
                        p.figure-text-right Add Card
                    .image-section 
                        img.left-image(
                            src="@/assets/images/swift-mockups/mockup-1.png",
                            data-depth="0.3"
                        )
                        p.figure-text-left Forgot Password

                VCol.section-title(variant="xs-5") Customer Application
                    VRow.overview-section-spacing
                        VCol(variant="xs-12")
                            .general-item.light-theme-trigger(
                                v-animate-onscroll="'animated fadeIn'"
                            )
                                span.title Restaurant Menu
                                p.description After you have checked-in to a restaurant, you can now view all of the menu items available. Again you have the option to filter by searching or via the pro- vided categories. The beverages and food menu’s appear below.
                                span.title Payment Method
                                p.description Swift offers a variety of payment options to allow customers to pay in the format that is most convenient to them.
                                span.title Menu Item
                                p.description Once you are on the specific menu item’s page, you are provided with ratings left by other users, the item’s description, the esti- mated preperation time and more. From here you can customise the item by selecting the Size, Quanitity and the various specific attributes of each item. Select the attributes you prefer and click “Add To Order” if you wish to purchase this menu item.
                                span.title Add Card
                                p.description Customers can easily add new card information which is stored securely.
                                span.title Forgot password
                                p.description Swift has an elaborate email notification system that triggers when the customer uses different sections of the application e.g. forgot password.

    .dark
        VGrid#management.container(variant="container")
            VRow
                VCol.section-title.light-text(variant="xs-5") Management Application
                    VRow.overview-section-spacing
                        VCol(variant="xs-12")
                            .general-item.dark-theme-trigger(
                                v-animate-onscroll="'animated fadeIn'"
                            )
                                span.title.light-text Managing Restaurants
                                p.description.light-text Anyone can register for the Swift management application and list their restaurant on the system. A user also has the option to create multiple restaurant branches, or even completely seperate businesses.
                                span.title.light-text Manage Menu
                                p.description.light-text Heading to the Menu Items section will list all the menu items available at your Restaurant. You can use the checkboxes on the left of each menu item to select multiple items if you need to use a bulk action (Delete, Export). Clicking on the title of any field will arrange the menu items according to that field.
                                span.title.light-text Management Dashboard
                                p.description.light-text The dashboard can be used as a centralized hub where a restaurant owner and the em- ployees can get a birds-eye view of the orders, tables, customers and menu items
                VCol.image-scroll-section(variant="xs-7")
                    .laptop-image-section.first
                        img.image(
                            src="@/assets/images/swift-mockups/Business.png",
                            data-depth="0.3"
                        )
                    .laptop-image-section 
                        img.image(
                            src="@/assets/images/swift-mockups/Menu.png",
                            data-depth="0.3"
                        )
                    .laptop-image-section 
                        img.image(
                            src="@/assets/images/swift-mockups/Dashboard.png",
                            data-depth="0.3"
                        ) 

    .light
        VGrid#solutions.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Technical Solutions
            VRow
                VCol(variant="xs-6") 
                    .general-item
                        span.title Problems
                        ol 
                            li.list-item 1. Asset-rich pages can lead to suboptimal performance and user experience.
                            li.list-item 2. A dynamic brand experience requires fresh content and frequent updates.
                            li.list-item 3. New restaurants must be added quickly and efficiently.
                            li.list-item 4. Ensure efficient, stable experiences for users across all devices.
                            li.list-item 5. A large system of design components may overwhelm internal teams.
                VCol(variant="xs-6") 
                    .general-item
                        span.title Solutions
                        ol 
                            li.list-item 1. High-performance media and assets served by Adobe’s best media management tools.
                            li.list-item 2. Streamlined content operations with custom CMS components and capabilities.
                            li.list-item 3. A strategic module system lets authors create content that isn’t stale or repetitive.
                            li.list-item 4. A custom and performance-tuned component and build system on the front end.
                            li.list-item 5. Robust code documentation and design guidelines ensures alignment across teams.

    .light
        VGrid#technologies.container(variant="container")
            VRow
                VCol.section-title.line(variant="xs-12") Technologies Used
            VRow.align-center
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/vue.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/node.png",
                        data-depth="0.3"
                    )
                VCol(variant="xs-2")
                    img.technology-img(
                        src="@/assets/images/technologies/google.png",
                        data-depth="0.3"
                    )

    .cream
        VGrid.container(variant="container")
            VRow.contact-us
                VCol(variant="xs-12")
                    h1.align-center.contact-description Want to work with us?
                    .align-center.scroll-down
                        router-link.contact-button.primary-button(
                            :to="{ name: 'home', query: { c: true } }",
                            data-cursor-shrink
                        ) Start A Project
                VCol(variant="xs-12")
                    .icon-scroll 
                    p.scroll-text Next Project: VitaminSea

    VGrid.container.project-content(variant="container")
        .title-section-wrapper
            .title-section-inner-wrapper
                .title-section-image(ref="parallax2")
                    img.main-image(
                        src="@/assets/images/vitaminsea/Mockup.jpg",
                        data-depth="0.3"
                    )
                    img.dot-pattern-2(
                        src="@/assets/dot-pattern-2.svg",
                        data-depth="0.05"
                    )
                    .outline-square-2(data-depth="0.15")
                    .filled-squares-2(data-depth="0.15")
                .title-section-content-container
                    .project-information
                        h1.title-section-title VitaminSea
                        .title-section-description
                            .company By Influx.Studio
                            .description VitaminSea is a beachside accommodation-sharing <br/> platform to connect prospective adventure-seekers <br/> to their ideal holiday getaway. It aims to provide <br/> targeted and personalised accommodations all<br/> across the world at your favourite tropical destinations.
                    .title-section-content-2
                        span.project-focus Project Focus <br/>
                        span.project-focus-items Branding, UI/UX, Web Development
                        .project-menu
                            .menu-item
                                a.label.active(data-link="#overview") 01 Overview
                            .menu-item
                                a.label(data-link="#project") 02 Project Demonstration
                            .menu-item
                                a.label(data-link="#solutions") 03 Solutions
                            .menu-item
                                a.label(data-link="#technologies") 04 Technologies
            .title-section-gridlines
    .static-elements
        .static-wrapper-inner.navigation-container
            //- Navigation.staticnav
        .static-wrapper-inner.static-footer
            p.copyright-info Copyright &copy; 2020 | Design by #[a(href="/contact") Influx Studios]
</template>

<script>
import Navigation from "@/components/navigation.vue";
// import { gsap } from "gsap";
import Parallax from "parallax-js";
import { EventBus } from "@/events/global-bus.js";
import ScrollMagic from "scrollmagic";
import $ from "jquery";

import Vue from "vue";
import FlexboxgridVue from "@vivid-web/flexboxgrid-vue";
import VueAnimateOnScroll from "vue-animate-onscroll";

Vue.use(VueAnimateOnScroll);

Vue.use(FlexboxgridVue);

export default {
    name: "Single-Work",
    computed: {
        workname() {
            return this.$route.params.workname;
        },
    },
    components: {
        Navigation,
    },
    metaInfo() {
        return {
            title: this.workname,
        };
    },
    mounted() {
        function scrollToElement(selector) {
            $("html, body")
                .stop(true, false)
                .animate(
                    {
                        scrollTop: $(selector).offset().top,
                    },
                    500,
                    "swing"
                );
        }

        $(document).on("click", ".menu-item a", function (e) {
            e.preventDefault();
            scrollToElement($(this).attr("data-link"));
            return false;
        });

        window.scrollTo(0, 0);

        new Parallax(this.$refs.parallax1, {
            relativeInput: true,
            calibrateX: true,
            calibrateY: true,
        });

        new Parallax(this.$refs.parallax2, {
            relativeInput: true,
            calibrateX: true,
            calibrateY: true,
        });

        let self = this;

        $(window).scroll(function () {
            if (
                $(window).scrollTop() + $(window).height() ==
                    $(document).height() &&
                self.$route.name == "swift"
            )
                self.$router.push({ name: "vitaminsea" });
        });

        var controller = new ScrollMagic.Controller();
        var revealElements = document.getElementsByClassName("carousel-scroll");
        for (var i = 0; i < revealElements.length; i++) {
            // create a scene for each element
            new ScrollMagic.Scene({
                triggerElement: revealElements[i], // y value not modified, so we can use element as trigger as well
                offset: 100, // start a little later
                triggerHook: 0.9,
                duration: "90%",
            })
                .setClassToggle(revealElements[i], "visible") // add class toggle
                .addTo(controller);
        }

        new ScrollMagic.Scene({
            triggerElement: "#customer",
            offset: 450,
            duration: 1150,
        })
            .setPin(".image-scroll-section")
            .setPin(".light-theme-trigger")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: "#management",
            offset: 350,
            duration: 850,
        })
            .setPin(".image-scroll-section")
            .setPin(".dark-theme-trigger")
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: ".scroll-down",
            offset: 0,
        })
            .on("start", function () {
                if (this.$route.name != "home" || this.$route.name != "works")
                    $("html, body").animate(
                        { scrollTop: $(document).height() },
                        2000
                    );
            })
            .addTo(controller);

        EventBus.$emit("rescan-cursor");
    },
    beforeDestroy() {
        $(window).off("scroll");
    },
};
</script>

<style lang="scss" scoped>
.main-wrapper {
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    height: 100%;
    background-color: $cl-cream;
    box-sizing: border-box;
    //
}
.nav-wrapper {
    margin-top: $body-padding-desktop-y;
    padding: 0 $body-padding-desktop-x;
}

// Title Layout Section
.title-section {
    position: relative;
    background-color: $cl-cream;
}

.title-section-gridlines {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
        to right,
        transparentize(#575757, 0.9),
        transparentize(#575757, 0.9) 1px,
        $cl-cream 1px,
        $cl-cream 10%
    );
    z-index: 0;
}

.title-section-wrapper {
    width: 100%;
    height: 100%;
    background-color: $cl-cream;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: $body-padding-desktop-y $body-padding-desktop-x;
    position: relative;
    z-index: 2;

    .title-section-inner-wrapper {
        position: relative;
        z-index: 2;
        display: flex;
        align-items: center;

        .title-section-title {
            color: $cl-grey;
            font-size: 7rem;
            line-height: 1.2em;
        }

        .title-section-image {
            margin-right: 8rem;
            position: relative;

            .main-image {
                max-width: 28rem;
                position: relative;
                z-index: 3;

                &.large {
                    max-width: 40rem;
                }
            }

            .dot-pattern {
                position: absolute;
                width: 70%;
                margin-left: -5rem;
                margin-top: 5rem;
                z-index: 1;
            }

            .outline-square {
                position: absolute;
                width: 75%;
                height: 100%;
                border: 1px solid $cl-grey;
                margin-top: -5rem;
                margin-left: 5rem;
                z-index: 1;
            }

            .filled-squares {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 2;

                &::before {
                    content: "";
                    position: absolute;
                    width: 9.6rem;
                    height: 9.6rem;
                    bottom: 3rem;
                    right: 1rem;
                    background-color: $cl-red;
                }
            }

            .dot-pattern-2 {
                position: absolute;
                width: 60%;
                margin-left: -7rem;
                margin-top: 16.5rem;
                z-index: 1;
            }

            .outline-square-2 {
                position: absolute;
                width: 75%;
                height: 75%;
                border: 1px solid $cl-grey;
                margin-top: -2rem;
                margin-left: 7rem;
                z-index: 1;
            }

            .filled-squares-2 {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 2;

                &::before {
                    content: "";
                    position: absolute;
                    width: 7rem;
                    height: 7rem;
                    bottom: 25rem;
                    right: -2.5rem;
                    background-color: $cl-red;
                }
            }
        }

        .title-section-content-container {
            margin-top: 4.8rem;

            .project-information {
                display: flex;
                flex-direction: row;
            }

            .title-section-content {
                margin-left: -5rem;
                margin-top: 15rem;
                font-weight: 500;
                font-size: 1.8rem;

                .project-focus {
                    font-weight: 600;
                    font-size: 1.6rem;
                }

                .project-focus-items {
                    font-weight: 500;
                    font-size: 1.6rem;
                }

                .project-menu {
                    margin-top: 4.8rem;
                    margin-bottom: 7rem;
                    display: flex;
                    flex-direction: row;

                    &.transition {
                        visibility: hidden;
                        // margin-bottom: 0;
                    }

                    .menu-item {
                        font-size: 1.6rem;
                        font-family: "Muli", Helvetica, sans-serif;
                        font-weight: 600;
                        position: relative;
                        padding-right: 3.2rem;
                        line-height: 2.8rem;
                        display: flex;
                        align-items: center;

                        a.label {
                            color: $cl-grey;
                            opacity: 0.8;
                            transition: opacity 150ms ease-in-out;

                            &:hover {
                                opacity: 1;
                            }

                            &.active {
                                position: relative;
                                &::after {
                                    bottom: 0;
                                    height: 2px;
                                    background-color: $cl-red;
                                    left: 0;
                                    width: 5rem;
                                    content: "";
                                    position: absolute;
                                }
                            }
                        }
                    }
                }
            }

            .title-section-content-2 {
                margin-left: 24rem;
                margin-top: 15rem;
                font-weight: 500;
                font-size: 1.8rem;

                .project-focus {
                    font-weight: 600;
                    font-size: 1.6rem;
                }

                .project-focus-items {
                    font-weight: 500;
                    font-size: 1.6rem;
                }

                .project-menu {
                    margin-top: 4.8rem;
                    margin-bottom: 7rem;
                    display: flex;
                    flex-direction: row;
                    .menu-item {
                        font-size: 1.6rem;
                        font-family: "Muli", Helvetica, sans-serif;
                        font-weight: 600;
                        position: relative;
                        padding-right: 3.2rem;
                        line-height: 2.8rem;
                        display: flex;
                        align-items: center;

                        a.label {
                            color: $cl-grey;
                            opacity: 0.8;
                            transition: opacity 150ms ease-in-out;

                            &:hover {
                                opacity: 1;
                            }

                            &.active {
                                position: relative;
                                &::after {
                                    bottom: 0;
                                    height: 2px;
                                    background-color: $cl-red;
                                    left: 0;
                                    width: 5rem;
                                    content: "";
                                    position: absolute;
                                }
                            }
                        }
                    }
                }
            }

            .title-section-description {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                margin-left: 14rem;
                white-space: nowrap;

                .company {
                    color: $cl-red;
                    font-weight: 600;
                    font-size: 1.4rem;
                }

                .description {
                    color: $cl-grey;
                    font-weight: 500;
                    font-size: 1.4rem;
                    margin-bottom: 1.8rem;
                }
            }
        }
    }
}

.light {
    background-color: white;
    position: relative;
    width: 100%;
}

.light-grey {
    background-color: #f6f6f6;
    position: relative;
    width: 100%;
}

.cream {
    background-color: $cl-cream;
    position: relative;
    width: 100%;
}

.dark {
    background-color: $cl-grey;
    position: relative;
    width: 100%;
}

.container {
    @media (min-width: 1200px) and (max-width: 1599px) {
        max-width: 80%;
    }

    @media (min-width: 1600px) {
        max-width: 75%;
    }

    &.project-content {
        height: 90vh;

        &.fade-in {
            animation: fadeIn ease 2s;
        }

        @keyframes fadeIn {
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        }
    }

    &.project-change {
        height: 100vh;
    }

    position: relative;

    .section-title {
        color: $cl-grey;
        font-size: 3rem;
        font-weight: 400;
        font-family: "Poppins", Helvetica, sans-serif;
        margin-top: 6rem;

        &.line {
            position: relative;
            &::after {
                bottom: 0;
                height: 3px;
                background-color: $cl-red;
                left: 0;
                width: 5rem;
                content: "";
                position: absolute;
            }
        }

        &.light-text {
            color: white;
        }
    }

    .align-center {
        display: flex;
        justify-content: center;
        margin-bottom: 5rem;
        margin-top: 1.5rem;

        .percentage {
            font-size: 4rem;
            color: $cl-red;
        }

        .results-description {
            font-size: 1.5rem;
            font-weight: 500;
        }
    }

    .icon-scroll,
    .icon-scroll:before {
        position: absolute;
        left: 50%;
        z-index: 100;
    }

    .scroll-text {
        font-size: 1.6rem;
        font-weight: 500;
        position: absolute;
        left: 52%;
        margin-top: 1rem;
        opacity: 0.7;
        margin-left: 1rem;
        z-index: 100;
    }

    .icon-scroll {
        width: 40px;
        height: 70px;
        margin-left: -20px;
        top: 100%;
        margin-top: -35px;
        box-shadow: inset 0 0 0 1px $cl-grey;
        border-radius: 25px;
    }

    .icon-scroll:before {
        content: "";
        width: 8px;
        height: 8px;
        background: $cl-grey;
        margin-left: -4px;
        top: 8px;
        border-radius: 4px;
        animation-duration: 1.5s;
        animation-iteration-count: infinite;
        animation-name: scroll;
    }

    @keyframes scroll {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
            transform: translateY(46px);
        }
    }

    .contact-us {
        display: flex;
        justify-content: center;
        margin-bottom: 2rem;
        margin-top: 1.5rem;

        .contact-description {
            font-size: 4rem;
            font-weight: 600;
            margin-top: 4rem;
            margin-bottom: 4rem;
        }

        .contact-button {
            background-color: $cl-cream;
            margin-top: 0;

            &:hover {
                background-color: $cl-red;
            }
        }

        &.align-center {
            display: flex;
            justify-content: center;
        }
    }

    .overview-section-spacing {
        margin-top: 1.5rem;
        margin-bottom: 4rem;
    }

    .image-carousel {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10rem;

        .carousel-item {
            width: 100rem;
        }
    }

    .side-scroll {
        margin-top: 3rem;
        margin-bottom: 6rem;

        .carousel-scroll {
            opacity: 0;
            transform: translateX(-40px);
            transition: all 0.6s ease-out;

            &.visible {
                opacity: 1;
                transform: none;
            }
        }
    }

    .slogan-section {
        display: flex;
        justify-content: center;
        text-align: center;

        .brand-slogan {
            font-weight: 600;
            font-size: 6rem;

            .slogan-outline {
                border: 3px solid $cl-red;
                padding-right: 2rem;
                padding-left: 2rem;
                transition: background-color 1s;

                /* &:hover {
                    color: white;
                    background-color: $cl-grey;
                } */
            }
        }
    }

    .image-scroll-section {
        display: flex;
        flex-direction: column;
        margin-top: 8rem;
        // margin-bottom: 5rem;

        .image-section {
            position: relative;
            margin-bottom: -20rem;

            .left-image {
                position: relative;
            }

            .right-image {
                position: relative;
                left: 30rem;
            }

            .figure-text-left {
                font-size: 1.3rem;
                font-weight: 800;
                margin-left: 2rem;

                &.light-text {
                    color: white;
                }
            }

            .figure-text-right {
                font-size: 1.3rem;
                font-weight: 800;
                text-align: center;
                margin-left: 2rem;

                &.light-text {
                    color: white;
                }
            }
        }

        .laptop-image-section {
            position: relative;
            margin-top: 2rem;

            &.first {
                margin-top: 6rem;
            }

            .image {
                position: relative;
            }
        }
    }

    .section-description {
        color: $cl-grey;
        font-weight: 500;
        font-size: 1.5rem;
        margin-top: 0rem;
        margin-bottom: 2rem;
    }

    .general-item {
        .title {
            color: $cl-grey;
            font-weight: 600;
            font-size: 2rem;
            font-family: "Poppins", Helvetica, sans-serif;

            &.light-text {
                color: white;
            }
        }

        .description {
            color: $cl-grey;
            font-weight: 500;
            font-size: 1.5rem;
            margin-top: 1rem;
            margin-bottom: 2rem;

            &.light-text {
                color: white;
            }
        }

        ol {
            line-height: 1.8em;
            margin-top: 1.5rem;
        }

        ol > li.list-item {
            font-weight: 500;
            font-size: 1.5rem;
        }
    }

    .general-section-share {
        font-weight: 700;
        font-size: 1.3rem;
    }

    .general-section-social-share {
        display: flex;
        flex-direction: row;
        margin-top: 1rem;

        .contact-info-social {
            &:hover {
                img {
                    opacity: 1;
                }
            }
            img {
                width: 2.2rem;
                height: 2.2rem;
                opacity: 0.75;
                transition: opacity 200ms ease-in-out;
            }

            &:not(:last-child) {
                margin-right: 1rem;
            }
        }
    }

    .general-section-project-scope {
        margin-top: 5rem;
        .scope {
            font-weight: 700;
            font-size: 1.4rem;
        }
        .scope-item {
            font-weight: 500;
            font-size: 1.3rem;
        }
    }

    .website-link {
        font-weight: 700;
        font-size: 1.4rem;
        color: $cl-red;

        &:hover {
            text-decoration: underline;
            text-decoration-color: $cl-grey;
        }

        &.spacing {
            margin-top: 5rem;
        }
    }

    .technology-img {
        filter: grayscale(100%);
        width: 20rem;
        height: 7rem;
        object-fit: contain;

        &:hover {
            filter: grayscale(0%);
        }
    }
}

.static-elements {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 99;
    padding: $body-padding-desktop-y $body-padding-desktop-x;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    pointer-events: none;

    .copyright-info {
        color: $cl-cream-darker;
    }

    @include respond-below(lg) {
        padding: $body-padding-mobile-y $body-padding-mobile-x;
        position: absolute;

        .copyright-info {
            display: none;
        }
    }
}
</style>